module.exports = __webpack_public_path__ + "media/application/images/colors/books_pink-79ecdd04090c9e9c7bb45549c01ae630.png";